
import React, { Component } from "react";
import { HashRouter as Router, Route, Redirect } from "react-router-dom";

import Auth from "./services/Auth";

import Home from "./containers/Home";
import Login from "./containers/Login";
import Logout from "./containers/Logout";
import Player from "./containers/Player";
import Monitor from "./containers/Monitor";
import Result from "./containers/Result";
import Feedback from "./containers/Feedback";
import Attributes from "./containers/Attributes";
import PublicResults from './containers/PublicResults'
import PrivateResults from './containers/PrivateResults'
import NewResults from './containers/NewResults'
import Users from './containers/Users'

import Header from "./components/Header";
import { fire } from "./fire";
import Creer from './containers/Create';
import Editer from './containers/Edit';
import 'assets/layout/buttons.css';


const PrivateRoute = ({ component: Component, ...rest }) => {

  return (
    <Route
      {...rest}
      render={props =>
        Auth.isAuth() ? (
          <RouteWithHeader component={Component} {...rest} {...props} />
        ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location }
              }}
            />
          )
      }
    />
  )
};

const PrivateRouteWithoutHeader = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      Auth.isAuth() ? (
        <Route component={Component} {...rest} {...props} />
      ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location }
            }}
          />
        )
    }
  />
);

const RouteWithoutHeader = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      <div className={rest.darkMode ? "bp3-dark" : ""}>
        <Route component={Component} {...rest} {...props} />
      </div>
    }
  />
)

const RouteWithHeader = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      <div className={rest.darkMode ? "bp3-dark" : ""}>
        <Header minimal={rest.minimalHeader} />
        <Component {...props} />
      </div>
    )}
  />
);

class App extends Component {


  render() {
    return (
      <Router>
        <div>
          <PrivateRoute exact path="/" component={Home} />
          <PrivateRoute exact path="/edit/:id" component={Editer} />
          <PrivateRoute
            exact
            path="/result/:id"
            component={Result}
            darkMode={true}
          />
          <PrivateRoute exact path="/feedback/:id" component={Feedback} />
          <PrivateRoute exact path="/attributes/:id" component={Attributes} />
          <PrivateRoute exact path="/create" component={Creer} />
          <PrivateRoute
            exact
            path="/monitor/:userId/:sessionShortname"
            component={Monitor}
            darkMode={true}
          />
          <RouteWithoutHeader
            exact
            path="/play/:userId/:sessionShortname"
            component={Player}
            darkMode={true}
            minimalHeader={true}
          />
          <Route exact path="/login" component={Login} />
          <Route exact path="/results/:id" component={PublicResults} />
          <Route exact path="/analyse/:id" component={PrivateResults} />
          <Route exact path="/analyses/:id" component={PrivateResults} />
          <Route exact path="/resultats/:uid/:id" component={NewResults} />

          <PrivateRouteWithoutHeader exact path="/logout" component={Logout} />
          <PrivateRoute exact path="/users" component={Users} />
        </div>
      </Router>
    );
  }

  componentDidMount() {
    this.onAuthChangeUnsub = fire
      .auth()
      .onAuthStateChanged(user => Auth.onAuthChange(user))
  }

  componentWillUnmount() {
    if (this.onAuthChangeUnsub != null) this.onAuthChangeUnsub();
    console.log(this.onAuthChangeUnsub())
  }

}

export default App;